import { useIntl } from 'react-intl';
import { Form, Modal, notification } from 'antd';

import SuppliersGeneralInfoForm from '@/components/Suppliers/SuppliersGeneralInfoForm';
import { SaveButton } from '@/components/_common/Buttons';
import { Supplier } from '@/core/domain/people/Suppliers/Suppliers.types';
import { useCreateSupplier } from '@/core/domain/people/Suppliers/Suppliers.hooks';
import SpaceForButton from '@/components/_common/SpaceForButtons';

type Props = {
  open: boolean;
  onClose: () => void;
  onSuccess?: (supplier: Supplier) => void;
};

function SuppliersCreateModal({ open, onClose, onSuccess }: Props) {
  const intl = useIntl();

  const [form] = Form.useForm<Supplier>();
  const createSupplier = useCreateSupplier();

  const handleSaveClick = async () => {
    try {
      const values = await form.validateFields();

      const obj = {
        ...values,
        active: true,
      };

      const response = await createSupplier.mutateAsync(obj);

      onSuccess?.(response);
      onClose();
      form.resetFields();
    } catch (err) {
      notification.error({
        message: intl.formatMessage({
          id: 'commons.form.notification.error',
        }),
        description: intl.formatMessage({
          id: 'commons.form.notification.errorDescription',
        }),
      });
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title="Cadastrar fornecedor"
      width={800}
      destroyOnClose
      footer={
        <SpaceForButton justifyContent="end">
          <SaveButton
            block
            onClick={handleSaveClick}
            loading={createSupplier.isLoading}
            disabled={createSupplier.isLoading}
          >
            Salvar
          </SaveButton>
        </SpaceForButton>
      }
    >
      <SuppliersGeneralInfoForm form={form} />
    </Modal>
  );
}

export default SuppliersCreateModal;
